import { useState } from "react";

//const API_BASE =
 // process.env.REACT_APP_API_BASE || "http://localhost:8080";
// for live later:
const API_BASE = "https://api.reignitespirit.com";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async () => {
    setMessage("");

    if (!email.trim()) {
      setMessage("Please enter your email.");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(`${API_BASE}/api/newsletter/subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email.trim(),
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(data?.message || "Unable to subscribe.");
        return;
      }

      setEmail("");
      setMessage(data?.message || "Subscribed successfully.");
    } catch (err) {
      console.error(err);
      setMessage("Newsletter service is currently unavailable.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mt-16 rounded-3xl border border-[#EB6AB5]/30 bg-gradient-to-br from-[#EB6AB5]/15 to-white/5 p-8 text-center">
      <p className="text-[#EB6AB5] font-bold uppercase tracking-[0.25em] text-sm">
        Stay Ahead of AI
      </p>

      <h2 className="text-3xl md:text-4xl font-extrabold mt-3">
        Receive weekly career insights
      </h2>

      <p className="text-white/70 max-w-2xl mx-auto mt-4">
        Get practical guidance on career pivots, financial runway planning,
        AI job risk, and local market intelligence.
      </p>

      <div className="mt-6 max-w-xl mx-auto flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="flex-1 px-5 py-4 rounded-full bg-[#0F0A24] border border-white/10 text-white outline-none focus:border-[#EB6AB5]"
        />

        <button
          onClick={subscribe}
          disabled={loading}
          className="px-7 py-4 rounded-full bg-[#EB6AB5] text-[#0F0A24] font-bold disabled:opacity-60"
        >
          {loading ? "Subscribing..." : "Subscribe"}
        </button>
      </div>

      {message && (
        <p className="mt-4 text-sm text-[#EB6AB5]">
          {message}
        </p>
      )}
    </section>
  );
}